import { render, staticRenderFns } from "./AddEmailModal.vue?vue&type=template&id=0830a490&"
import script from "./AddEmailModal.vue?vue&type=script&lang=ts&"
export * from "./AddEmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0830a490')) {
      api.createRecord('0830a490', component.options)
    } else {
      api.reload('0830a490', component.options)
    }
    module.hot.accept("./AddEmailModal.vue?vue&type=template&id=0830a490&", function () {
      api.rerender('0830a490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/email/AddEmailModal.vue"
export default component.exports